import {
  getInfoUserProfileRequest,
  updateUltimoAvisoRequest,
} from 'store/app/requests';
import {
  makeSelectFinishTimeSelectedJourneyPristine,
  makeSelectFinishTimeSelectedServicePristine,
  makeSelectIdTypePracticeSelected,
  makeSelectMinutesPracticeSelected,
  makeSelectStartDateTimeSelectedPreparation,
  makeSelectStartTimeSelectedJourneyPristine,
  makeSelectStartTimeSelectedPreparationPristine,
  makeSelectStartTimeSelectedServicePristine,
} from 'store/app/selectors';
import {
  setStartPreparationSelectedError,
  setInfoUserProfileStatus,
  setPostUpdateUltimoAviso,
  resetCreatePracticeFormError,
} from './actions';
import { call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import ActionTypes from 'store/app/actionTypes';
import { getTokenRequest } from 'store/oauth/actions';
import PracticasActionTypes from 'store/practicas/actionTypes';
import {
  resetCreatePracticeForm,
  resetSelectedCourses,
  resetSelectedStudents,
  setDateMaxSelected,
  setDateMinSelected,
  setMinutesPracticeSelected,
  setMinutesPracticeSelectedError,
  setStartJourneySelectedErrorDraft,
  setFinishTimeJourneySelectedErrorDraft,
  setStartServiceSelectedErrorDraft,
  setFinishTimeServiceSelectedErrorDraft,
} from 'store/app/actions';
import {
  makeSelectFechaMaximaPractica,
  makeSelectFechaMinimaPractica,
} from 'store/practicas/selectors';
import { getPracticaSeleccionadaRequest } from 'store/practicas/actions';
import {
  getAlumnoAuditoriaRequestSaga,
  getCursosActivosJornadaRequestSaga,
  getCursosAuditoriaRequestSaga,
  getEstadosPracticaRequestSaga,
  getFilterAlumnoPracticaRequestSaga,
  getFilterCursoPracticaRequestSaga,
  getInfoUserRequestSaga,
  getPracticaSeleccionadaToEditRequestSaga,
  getPracticasRequestSaga,
  getProvinciasAuditoriaRequestSaga,
  getSociedadesRequestSaga as getSociedadesPracticasRequestSaga,
} from 'store/practicas/sagas';
import {
  getEstadosCursosRequest,
  getFilterAlumnoPracticaRequest,
  getSociedadesRequest,
} from 'store/practicas/requests';
import { ResponseFetcher } from 'utils/fetcher/types';
import { makeSelectTokenBearerToken } from 'store/oauth/selectors';
import { makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected } from 'store/usuarios/selectors';
import { getCursoSeleccionado, getInfoUsersRequest } from './requests';
import {
  FechaMaximaPractica,
  FechaMinimaPractica,
} from 'store/practicas/types';

import { RouteTypes } from '../../consts';
import {
  makeSelectFinishDateTimeSelectedJourney,
  makeSelectUsername,
  makeSelectFinishDateTimeSelectedService,
  makeSelectStartDateTimeSelectedJourney,
  makeSelectStartDateTimeSelectedService,
} from './selectors';
import { language } from '../../utils/literals';

export default function* sagas() {
  yield takeLatest(
    [
      ActionTypes.SET_USERNAME,
      ActionTypes.SET_PASSWORD,
      ActionTypes.SET_USERNAME_PASSWORD,
    ],
    setUsernamePasswordSaga
  );
  yield takeEvery(
    ActionTypes.GET_INFO_USER_PROFILE,
    getInfoUserProfileRequestSaga
  );

  yield takeEvery(
    ActionTypes.UPDATE_INFO_USER_PROFILE,
    postUpdateInfoUserProfileRequestSaga
  );
  yield takeEvery([ActionTypes.SET_PROFILE_SELECTED], setProfileSelectedSaga);
  yield takeEvery(
    [
      PracticasActionTypes.SET_FECHA_MINIMA_PRACTICA,
      PracticasActionTypes.SET_FECHA_MAXIMA_PRACTICA,
      ActionTypes.RESET_CREATE_PRACTICE_FORM,
    ],
    setDateMinMaxSelectedSaga
  );

  yield takeLatest(
    [ActionTypes.RESET_CREATE_PRACTICE_FORM],
    getCursosActivosJornadaRequestSaga
  );

  yield takeEvery(
    ActionTypes.SET_PRACTICA_EDITAR,
    getPracticaSeleccionadaToEditRequestSaga
  );

  yield takeEvery(
    [ActionTypes.SET_SELECTED_COURSES],
    getFilterAlumnoPracticaRequestSaga
  );

  yield takeEvery(ActionTypes.SET_USER_LIST, getInfoUserRequestSaga);

  yield takeLatest(
    [ActionTypes.SET_SELECTED_SOCIETIES],
    autoUpdateSocietySelected
  );

  // Control de formulario de práctica
  yield takeLatest(
    [
      ActionTypes.SET_JORNADA_SELECCIONADA,
      ActionTypes.SET_START_DATE_TIME_SELECTED_JOURNEY,
      ActionTypes.SET_START_TIME_SELECTED_JOURNEY_PRISTINE,
      ActionTypes.SET_FINISH_DATE_TIME_SELECTED_JOURNEY,
      ActionTypes.SET_FINISH_TIME_SELECTED_JOURNEY_PRISTINE,
      ActionTypes.SET_START_DATE_TIME_SELECTED_PREPARATION,
      ActionTypes.SET_START_TIME_SELECTED_PREPARATION_PRISTINE,
      ActionTypes.SET_START_DATE_TIME_SELECTED_SERVICE,
      ActionTypes.SET_START_TIME_SELECTED_SERVICE_PRISTINE,
      ActionTypes.SET_FINISH_DATE_TIME_SELECTED_SERVICE,
      ActionTypes.SET_FINISH_TIME_SELECTED_SERVICE_PRISTINE,
      ActionTypes.SET_ID_TYPE_PRACTICE_SELECTED,
      ActionTypes.SET_MINUTES_PRACTICE_SELECTED,
    ],
    checkFormPracticeErrors
  );

  yield takeLatest(
    [
      ActionTypes.SET_START_DATE_TIME_SELECTED_PREPARATION,
      ActionTypes.SET_START_TIME_SELECTED_PREPARATION_PRISTINE,
      ActionTypes.SET_START_DATE_TIME_SELECTED_SERVICE,
      ActionTypes.SET_START_TIME_SELECTED_SERVICE_PRISTINE,
      ActionTypes.SET_FINISH_DATE_TIME_SELECTED_SERVICE,
      ActionTypes.SET_FINISH_TIME_SELECTED_SERVICE_PRISTINE,
    ],
    calculateMinutesPracticeSelected
  );
}

export function* getPracticaSeleccionadaRequestSaga() {
  yield put(getPracticaSeleccionadaRequest());
}

export function* setUsernamePasswordSaga() {
  yield put(getTokenRequest());
}

export function* setDateMinMaxSelectedSaga() {
  const fechaMinimaPractica: FechaMinimaPractica = yield select(
    makeSelectFechaMinimaPractica()
  );
  const fechaMaximaPractica: FechaMaximaPractica = yield select(
    makeSelectFechaMaximaPractica()
  );

  yield put(setDateMinSelected(fechaMinimaPractica));
  yield put(setDateMaxSelected(fechaMaximaPractica));
}

export function* setProfileSelectedSaga() {
  yield put(resetCreatePracticeForm());
  yield call(getEstadosPracticaRequestSaga);
  yield call(getFilterCursoPracticaRequestSaga, {});
  yield call(getFilterAlumnoPracticaRequestSaga, {});
  yield call(getSociedadesPracticasRequestSaga);
  yield call(getPracticasRequestSaga);
}

export function* autoUpdateSocietySelected() {
  switch (window.location.pathname) {
    case `${RouteTypes.AUDIT}`:
      yield call(getAlumnoAuditoriaRequestSaga);
      yield call(getCursosAuditoriaRequestSaga);
      yield call(getProvinciasAuditoriaRequestSaga);
      break;
    case `${RouteTypes.HOME}`:
      yield put(resetSelectedStudents());
      yield put(resetSelectedCourses());
      yield call(getFilterAlumnoPracticaRequestSaga, {});
      yield call(getFilterCursoPracticaRequestSaga, {});
      break;

    default:
      break;
  }
}

export function* getFilterAlumnosRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,

    // cursoId: params.payload.cursoId
    ...params,

    // sociedades: perfilSelected?.ID_PERFIL === userProfile.administrador ? (sociedadAudit ? sociedadAudit.join() : '') : '',
    // cursos:
    //   selectedCourses && Array.isArray(selectedCourses)
    //     ? selectedCourses.join()
    //     : '',
    // alumnos: selectedAlumno ? selectedAlumno.join() : '',
    // provincias: provi.toString() ? provi.toString() : '',
  };
  const bearerToken = yield select(makeSelectTokenBearerToken());
  const response: ResponseFetcher<any> = yield call(
    getFilterAlumnoPracticaRequest,
    payload,
    bearerToken
  );

  return response;
}

export function* getSociedadesRequestSaga(params) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    ...params,
  };
  const bearerToken = yield select(makeSelectTokenBearerToken());
  const response: ResponseFetcher<any> = yield call(
    getSociedadesRequest,
    payload,
    bearerToken
  );

  return response;
}


export function* getEstadosCursosRequestSaga(/* params */) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    /* ...params */
  };
  const bearerToken = yield select(makeSelectTokenBearerToken());
  const response: ResponseFetcher<any> = yield call(
    getEstadosCursosRequest,
    payload,
    bearerToken
  );

  return response;
}

// getInfoUserProfile
export function* getInfoUserProfileRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      user: usuario,
      profile: perfilSelected?.ID_PERFIL,
      /* ...params */
    };
    const response: ResponseFetcher<any> = yield call(
      getInfoUserProfileRequest,
      payload
      // bearerToken
    );
    if (response.ok) {
      yield put(setInfoUserProfileStatus(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.GET_INFO_USER_PROFILE}`);
    }
    // return response;
  } catch (err) {
    console.error(err);
  }
}

// postUpdateInfoUserProfile
export function* postUpdateInfoUserProfileRequestSaga() {
  try {
    const usuario = yield select(makeSelectUsername());
    const perfilSelected = yield select(
      makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
    );

    const payload: any = {
      usuario,
      perfilId: perfilSelected?.ID_PERFIL,
      user: usuario,
      profile: perfilSelected?.ID_PERFIL,
    };
    const response: ResponseFetcher<any> = yield call(
      updateUltimoAvisoRequest,
      payload
    );
    if (response.ok) {
      yield put(setPostUpdateUltimoAviso(response.data));
    } else {
      throw new Error(`Error: ${ActionTypes.UPDATE_INFO_USER_PROFILE}`);
    }
  } catch (err) {
    console.error(err);
  }
}

export function* getInfoUsersRequestSaga(listadoUsuarios: string) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    listadoUsuarios,
  };
  const bearerToken = yield select(makeSelectTokenBearerToken());
  const response: ResponseFetcher<any> = yield call(
    getInfoUsersRequest,
    payload,
    bearerToken
  );

  return response;
}

export function* getCursoSeleccionadoRequestSaga(cursoId: string) {
  const usuario = yield select(makeSelectUsername());
  const perfilSelected = yield select(
    makeSelectPerfilesUsuarioDatosPerfilesUsuarioSelected()
  );

  const payload: any = {
    usuario,
    perfilId: perfilSelected?.ID_PERFIL,
    cursoId,
  };
  const bearerToken = yield select(makeSelectTokenBearerToken());
  const response: ResponseFetcher<any> = yield call(
    getCursoSeleccionado,
    payload,
    bearerToken
  );

  return response;
}

// Control de formulario de crear práctica

const isJourneyFinishBeforeStart = (
  startDateTimeSelectedJourney: any,
  finishDateTimeSelectedJourney: any,
  startTimeSelectedJourneyPristine: any,
  finishTimeSelectedJourneyPristine: any
): boolean =>
  !!startDateTimeSelectedJourney &&
  !!finishDateTimeSelectedJourney &&
  !startTimeSelectedJourneyPristine &&
  !finishTimeSelectedJourneyPristine &&
  startDateTimeSelectedJourney >= finishDateTimeSelectedJourney;

const isJourneyStartAfterNow = (
  startDateTimeSelectedJourney: any,
  startTimeSelectedJourneyPristine: any,
  nowDate: Date
): boolean =>
  !!startDateTimeSelectedJourney &&
  !startTimeSelectedJourneyPristine &&
  startDateTimeSelectedJourney > nowDate;

const isPreparationOutOfRange = (
  startDateTimeSelectedPreparation: any,
  startTimeSelectedPreparationPristine: any,
  idTypePracticeSelected: any,
  startTimeSelectedJourneyPristine: any,
  startDateTimeSelectedService: any,
  startDateTimeSelectedJourney: any,
  startTimeSelectedServicePristine: any
): boolean =>
  !!startDateTimeSelectedPreparation &&
  !startTimeSelectedPreparationPristine &&
  !!idTypePracticeSelected &&
  idTypePracticeSelected !== 'PC' &&
  (((!startTimeSelectedJourneyPristine &&
    !!startDateTimeSelectedService &&
    startDateTimeSelectedPreparation < startDateTimeSelectedJourney) ||
    (!!startDateTimeSelectedService &&
      !startTimeSelectedServicePristine &&
      startDateTimeSelectedPreparation >= startDateTimeSelectedService)));

const isServiceStartOutOfJourneyRange = (
  startDateTimeSelectedService: any,
  startTimeSelectedServicePristine: any,
  startDateTimeSelectedJourney: any,
  finishDateTimeSelectedJourney: any,
  startTimeSelectedJourneyPristine: any,
  finishTimeSelectedJourneyPristine: any
): boolean =>
  !!startDateTimeSelectedService &&
  !startTimeSelectedServicePristine &&
  !!startDateTimeSelectedJourney &&
  !!finishDateTimeSelectedJourney &&
  !startTimeSelectedJourneyPristine &&
  !finishTimeSelectedJourneyPristine &&
  (startDateTimeSelectedService < startDateTimeSelectedJourney ||
    startDateTimeSelectedService > finishDateTimeSelectedJourney);

const isServiceStartAfterNow = (
  startDateTimeSelectedService: any,
  startTimeSelectedServicePristine: any,
  nowDate: Date
): boolean =>
  !!startDateTimeSelectedService &&
  !startTimeSelectedServicePristine &&
  startDateTimeSelectedService > nowDate;

const isServiceFinishOutOfJourneyRange = (
  finishDateTimeSelectedService: any,
  finishTimeSelectedServicePristine: any,
  startDateTimeSelectedJourney: any,
  finishDateTimeSelectedJourney: any,
  startTimeSelectedJourneyPristine: any,
  finishTimeSelectedJourneyPristine: any
): boolean =>
  !!finishDateTimeSelectedService &&
  !finishTimeSelectedServicePristine &&
  !!startDateTimeSelectedJourney &&
  !!finishDateTimeSelectedJourney &&
  !startTimeSelectedJourneyPristine &&
  !finishTimeSelectedJourneyPristine &&
  (finishDateTimeSelectedService < startDateTimeSelectedJourney ||
    finishDateTimeSelectedService > finishDateTimeSelectedJourney);

const isServiceFinishBeforeStart = (
  startDateTimeSelectedService: any,
  finishDateTimeSelectedService: any,
  startTimeSelectedServicePristine: any,
  finishTimeSelectedServicePristine: any
): boolean =>
  !!startDateTimeSelectedService &&
  !!finishDateTimeSelectedService &&
  !startTimeSelectedServicePristine &&
  !finishTimeSelectedServicePristine &&
  startDateTimeSelectedService >= finishDateTimeSelectedService;

const isMinutesPracticeHigher480 = (minutesPracticeSelected: any): boolean =>
  !!minutesPracticeSelected && minutesPracticeSelected > 480;

function* checkFormPracticeErrors({ type }) {
  // Control de formulario de práctica
  // En esta función sólo se tocan errores, no se setean variables de datos del form

  // Limpiar formularios
  yield call(clearFormPracticeErrors);

  // Datos del formulario
  const startDateTimeSelectedJourney = yield select(
    makeSelectStartDateTimeSelectedJourney()
  );
  const finishDateTimeSelectedJourney = yield select(
    makeSelectFinishDateTimeSelectedJourney()
  );
  const startTimeSelectedJourneyPristine = yield select(
    makeSelectStartTimeSelectedJourneyPristine()
  );
  const finishTimeSelectedJourneyPristine = yield select(
    makeSelectFinishTimeSelectedJourneyPristine()
  );
  const startDateTimeSelectedPreparation = yield select(
    makeSelectStartDateTimeSelectedPreparation()
  );
  const startTimeSelectedPreparationPristine = yield select(
    makeSelectStartTimeSelectedPreparationPristine()
  );
  const idTypePracticeSelected = yield select(
    makeSelectIdTypePracticeSelected()
  );
  const startDateTimeSelectedService = yield select(
    makeSelectStartDateTimeSelectedService()
  );
  const finishDateTimeSelectedService = yield select(
    makeSelectFinishDateTimeSelectedService()
  );
  const startTimeSelectedServicePristine = yield select(
    makeSelectStartTimeSelectedServicePristine()
  );
  const finishTimeSelectedServicePristine = yield select(
    makeSelectFinishTimeSelectedServicePristine()
  );
  const minutesPracticeSelected = yield select(
    makeSelectMinutesPracticeSelected()
  );
  const nowDate = getNowDate();

  // Jornada: la fecha de inicio no puede ser posterior o igual a la de fin
  if (
    isJourneyFinishBeforeStart(
      startDateTimeSelectedJourney,
      finishDateTimeSelectedJourney,
      startTimeSelectedJourneyPristine,
      finishTimeSelectedJourneyPristine
    )
  ) {
    yield put(
      setFinishTimeJourneySelectedErrorDraft(
        language.validations.dateIsBeforeOrEqualsStart
      )
    );
  }

  // Jornada: la fecha de inicio no puede ser posterior a la actual
  if (
    isJourneyStartAfterNow(
      startDateTimeSelectedJourney,
      startTimeSelectedJourneyPristine,
      nowDate
    )
  ) {
    yield put(
      setStartJourneySelectedErrorDraft(
        language.validations.dateIsEqualsOrAfterNow
      )
    );
  }

  // Puesta a disposición: si está habilitada (con valor y diferente de PC) debe
  // estar entre el inicio de jornada y el inicio del servicio (puede ser igual al
  // inicio de la jornada pero no igual al inicio del servicio)
  if (
    isPreparationOutOfRange(
      startDateTimeSelectedPreparation,
      startTimeSelectedPreparationPristine,
      idTypePracticeSelected,
      startTimeSelectedJourneyPristine,
      startDateTimeSelectedService,
      startDateTimeSelectedJourney,
      startTimeSelectedServicePristine
    )
  ) {
    yield put(
      setStartPreparationSelectedError(language.validations.dateIsNotBetween)
    );
  }

  // Servicio: la fecha de inicio del servicio debe estar dentro del rango de la jornada
  // (se admiten iguales)
  if (
    isServiceStartOutOfJourneyRange(
      startDateTimeSelectedService,
      startTimeSelectedServicePristine,
      startDateTimeSelectedJourney,
      finishDateTimeSelectedJourney,
      startTimeSelectedJourneyPristine,
      finishTimeSelectedJourneyPristine
    )
  ) {
    yield put(
      setStartServiceSelectedErrorDraft(language.validations.dateIsNotBetween)
    );
  }

  // Servicio: la fecha de inicio no puede ser posterior a la actual
  if (
    isServiceStartAfterNow(
      startDateTimeSelectedService,
      startTimeSelectedServicePristine,
      nowDate
    )
  ) {
    yield put(
      setStartServiceSelectedErrorDraft(
        language.validations.dateIsEqualsOrAfterNow
      )
    );
  }

  // Servicio: la fecha de fin del servicio debe estar dentro del rango de la jornada
  // (se admiten iguales)
  if (
    isServiceFinishOutOfJourneyRange(
      finishDateTimeSelectedService,
      finishTimeSelectedServicePristine,
      startDateTimeSelectedJourney,
      finishDateTimeSelectedJourney,
      startTimeSelectedJourneyPristine,
      finishTimeSelectedJourneyPristine
    )
  ) {
    yield put(
      setFinishTimeServiceSelectedErrorDraft(
        language.validations.dateIsNotBetween
      )
    );
  }

  // Servicio: la fecha de inicio no puede ser posterior o igual a la de fin
  if (
    isServiceFinishBeforeStart(
      startDateTimeSelectedService,
      finishDateTimeSelectedService,
      startTimeSelectedServicePristine,
      finishTimeSelectedServicePristine
    )
  ) {
    yield put(
      setFinishTimeServiceSelectedErrorDraft(
        language.validations.dateIsBeforeOrEqualsStart
      )
    );
  }

  // Minutos: no se pueden superar los 480 minutos
  if (isMinutesPracticeHigher480(minutesPracticeSelected)) {
    yield put(
      setMinutesPracticeSelectedError(
        language.validations.minutesPracticeHigher480
      )
    );
  }
}

function* clearFormPracticeErrors() {
  yield put(resetCreatePracticeFormError());
}

function getNowDate(): Date {
  const nowDate = new Date();
  nowDate.setMilliseconds(0);
  return nowDate;
}

// Cálculo de los minutos

function* calculateMinutesPracticeSelected({ type }) {
  // Datos
  const startDateTimeSelectedPreparation = yield select(
    makeSelectStartDateTimeSelectedPreparation()
  );
  const startTimeSelectedPreparationPristine = yield select(
    makeSelectStartTimeSelectedPreparationPristine()
  );
  const startDateTimeSelectedService = yield select(
    makeSelectStartDateTimeSelectedService()
  );
  const startTimeSelectedServicePristine = yield select(
    makeSelectStartTimeSelectedServicePristine()
  );
  const finishDateTimeSelectedService = yield select(
    makeSelectFinishDateTimeSelectedService()
  );
  const finishTimeSelectedServicePristine = yield select(
    makeSelectFinishTimeSelectedServicePristine()
  );

  // Cálculo
  let minutes: number | null = null;
  if (
    !!startDateTimeSelectedService &&
    !!finishDateTimeSelectedService &&
    !startTimeSelectedServicePristine &&
    !finishTimeSelectedServicePristine &&
    startDateTimeSelectedService < finishDateTimeSelectedService
  ) {
    if (
      !!startDateTimeSelectedPreparation &&
      !startTimeSelectedPreparationPristine
    ) {
      if (
        startTimeSelectedPreparationPristine < finishDateTimeSelectedService
      ) {
        minutes = getMinutesBetweenDates(
          startDateTimeSelectedPreparation,
          finishDateTimeSelectedService
        );
      }
    } else {
      minutes = getMinutesBetweenDates(
        startDateTimeSelectedService,
        finishDateTimeSelectedService
      );
    }
  }
  yield put(setMinutesPracticeSelected(minutes));
}

function getMinutesBetweenDates(fromDate: Date, toDate: Date): number {
  let diff = (toDate.getTime() - fromDate.getTime()) / 1000;
  diff /= 60;
  return Math.abs(Math.round(diff));
}
